import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetPriceMap_memberPackage$key } from "./__generated__/useGetPriceMap_memberPackage.graphql";

export const useGetPriceMap = (
  memberPackageRef: useGetPriceMap_memberPackage$key | undefined | null
) => {
  const memberPackage = useFragment(
    useGetPriceMapFragmentString,
    memberPackageRef
  );

  const pricingMap = memberPackage?.package?.billingOptions?.reduce(
    (map, option) => {
      option?.billingCharges?.forEach((charge) => {
        if (
          charge?.frequency &&
          charge?.squareVariation?.amount !== undefined &&
          charge?.squareVariation?.amount !== null
        ) {
          map[charge.frequency] = charge.squareVariation.amount;
        }
      });
      return map;
    },
    {} as Record<string, number>
  );

  return pricingMap;
};

const useGetPriceMapFragmentString = graphql`
  fragment useGetPriceMap_memberPackage on MemberPackage {
    package {
      billingOptions {
        billingCharges {
          frequency
          squareVariation {
            amount
          }
        }
      }
    }
  }
`;
